import { __assign } from "tslib";
import React from 'react';
import { standardEditorsRegistry, } from '@savantly/sprout-api';
import { Switch } from '../components/Switch/Switch';
import { NumberValueEditor, RadioButtonGroup, StringValueEditor, StringArrayEditor, SelectValueEditor, TimeZonePicker, } from '../components';
import { ColorValueEditor } from '../components/OptionsUI/color';
/**
 * Returns collection of common field config properties definitions
 */
export var getStandardFieldConfigs = function () {
    var category = ['Standard options'];
    var displayName = {
        id: 'displayName',
        path: 'displayName',
        name: 'Display name',
        description: 'Change the field or series name',
        editor: standardEditorsRegistry.get('text').editor,
        settings: {
            placeholder: 'none',
            expandTemplateVars: true,
        },
        category: category,
    };
    var unit = {
        id: 'unit',
        path: 'unit',
        name: 'Unit',
        description: '',
        editor: standardEditorsRegistry.get('unit').editor,
        settings: {
            placeholder: 'none',
        },
        category: category,
    };
    var min = {
        id: 'min',
        path: 'min',
        name: 'Min',
        description: 'Leave empty to calculate based on all values',
        editor: standardEditorsRegistry.get('number').editor,
        settings: {
            placeholder: 'auto',
        },
        category: category,
    };
    var max = {
        id: 'max',
        path: 'max',
        name: 'Max',
        description: 'Leave empty to calculate based on all values',
        editor: standardEditorsRegistry.get('number').editor,
        settings: {
            placeholder: 'auto',
        },
        category: category,
    };
    var decimals = {
        id: 'decimals',
        path: 'decimals',
        name: 'Decimals',
        editor: standardEditorsRegistry.get('number').editor,
        settings: {
            placeholder: 'auto',
            min: 0,
            max: 15,
            integer: true,
        },
        category: category,
    };
    var noValue = {
        id: 'noValue',
        path: 'noValue',
        name: 'No Value',
        description: 'What to show when there is no value',
        editor: standardEditorsRegistry.get('text').editor,
        settings: {
            placeholder: '-',
        },
        category: category,
    };
    // const color: FieldConfigPropertyItem<any, string, StringFieldConfigSettings> = {
    //   id: 'color',
    //   path: 'color',
    //   name: 'Color',
    //   description: 'Customise color',
    //   editor: standardEditorsRegistry.get('color').editor as any,
    //   override: standardEditorsRegistry.get('color').editor as any,
    //   process: identityOverrideProcessor,
    //   settings: {
    //     placeholder: '-',
    //   },
    //   shouldApply: field => field.type !== FieldType.time,
    //   category,
    // };
    return [unit, min, max, decimals, displayName, noValue];
};
/**
 * Returns collection of standard option editors definitions
 */
export var getStandardOptionEditors = function () {
    var number = {
        id: 'number',
        name: 'Number',
        description: 'Allows numeric values input',
        editor: NumberValueEditor,
    };
    var text = {
        id: 'text',
        name: 'Text',
        description: 'Allows string values input',
        editor: StringValueEditor,
    };
    var strings = {
        id: 'strings',
        name: 'String array',
        description: 'An array of strings',
        editor: StringArrayEditor,
    };
    var boolean = {
        id: 'boolean',
        name: 'Boolean',
        description: 'Allows boolean values input',
        editor: function (props) { return React.createElement(Switch, __assign({}, props, { onChange: function (e) { return props.onChange(e.currentTarget.checked); } })); },
    };
    var select = {
        id: 'select',
        name: 'Select',
        description: 'Allows option selection',
        editor: SelectValueEditor,
    };
    var radio = {
        id: 'radio',
        name: 'Radio',
        description: 'Allows option selection',
        editor: function (props) { var _a; return React.createElement(RadioButtonGroup, __assign({}, props, { options: (_a = props.item.settings) === null || _a === void 0 ? void 0 : _a.options })); },
    };
    var color = {
        id: 'color',
        name: 'Color',
        description: 'Allows color selection',
        editor: ColorValueEditor,
    };
    var timeZone = {
        id: 'timezone',
        name: 'Time Zone',
        description: 'Time zone selection',
        editor: TimeZonePicker,
    };
    return [
        text,
        number,
        boolean,
        radio,
        select,
        strings,
        timeZone,
        color,
    ];
};
//# sourceMappingURL=standardEditors.js.map